import React from "react";

import AnnotationMarkerBadge from "./AnnotationMarkerBadge";
import AnnotationMarkerGlyph from "./AnnotationMarkerGlyph";
import AnnotationMarkerHoverCard from "./AnnotationMarkerHoverCard";
import type { AnnotationMarkerReadModel } from "./annotationMarker.types";

export default function AnnotationMarkerRenderer({
  marker,
  hovered,
}: {
  marker: AnnotationMarkerReadModel;
  hovered: boolean;
}): JSX.Element {
  if (!marker.projection.markerVisible) {
    return <></>;
  }

  return (
    <>
      <AnnotationMarkerGlyph marker={marker} />
      <AnnotationMarkerBadge marker={marker} />
      {hovered ? <AnnotationMarkerHoverCard marker={marker} /> : null}
    </>
  );
}